import { render } from "./Subcategory.vue?vue&type=template&id=f39707a2&scoped=true"
import script from "./Subcategory.vue?vue&type=script&lang=js"
export * from "./Subcategory.vue?vue&type=script&lang=js"

import "./Subcategory.vue?vue&type=style&index=0&id=f39707a2&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f39707a2"]])

export default __exports__